<template>
  <div class="HomePage">
    <div style="width: 100%; height: 100%">
      <div class="pageTitle">
        <div class="titleBg">
          <div class="titleBox">
            <div class="boxImg"><img :src="imgLogo" /></div>
            <div class="boxStyle">
              <span class="infoTxt">{{ date }}</span>
              <span class="infoTxt">{{ time }}</span>
            </div>
          </div>
          <div class="titleStyle">{{ $t('HomPage.MasterKong.ManagementPlatform') }}</div>
          <div class="titleBox">
            <div class="boxRight">
              <div class="rightInfo">
                <span class="titleBtn" @click="toggleFullScreen">
                  <i :class="this.iFullScreen
                    ? 'iconfont iconchuangkouhuanyuan'
                    : 'iconfont iconfangda'
                    " :title="$t('HomPage.toggleFullScreen')">
                  </i>{{ this.iFullScreen ? this.$t('HomPage.exitFullScreen') : this.$t('HomPage.fullScreen') }}
                </span>
                <span class="titleBtn" @click="btnEnter"><i class="iconfont iconicon-houtaiguanli"></i>{{
                  $t('HomPage.backManagement') }}</span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <el-row style="height: 90%">
        <el-col :span="6" class="homeLeft">
          <div class="upBox">
            <div class="leftUp">
              <div class="upAll">
                <div class="title">
                  <span>{{ $t("HomPage.MasterKong.VehicleConditionDay") }}</span>
                </div>
                <el-row class="upFlex">
                  <el-col :span="12">
                    <div v-if="isValue" v-loading="carLoading">
                      <linegraph :id="'carBargraph'" :data="carOption" style="height: 160px"></linegraph>
                    </div>
                    <div v-else style="
                        color: #868686;
                        font-size: 16px;
                        text-align: center;
                        line-height: 115px;
                      ">
                      {{ $t('common.noData') }}
                    </div>
                  </el-col>
                  <el-col :span="10" class="flexLenged" style="margin-top: 40px;">
                    <div class="dotTitle"><span>在线数(台)：</span><span style="color: #00FB82;">{{ likeCount }}</span>
                    </div>
                    <!-- <div class="dotTitle"><span>离线数(台)：</span><span style="color: #FBA700;">{{ offlineCount }}</span>
                    </div> -->
                    <div class="dotTitle"><span>报停数(台)：</span><span style="color: #FB2900;">{{ problemCount }}</span>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="downBox">
            <div class="leftUp">
              <div class="upAll">
                <div class="title">
                  <span>{{ $t("HomPage.MasterKong.VehicleConditionBranchOffice") }}</span>
                </div>
                <div>
                  <div v-loading="companyStatusLoading">
                    <linegraph :id="'companyStatusBargraph'" :data="companyStatusOption" style="height: 230px">
                    </linegraph>
                  </div>
                  <!-- <div v-else style="
                        color: #868686;
                        font-size: 16px;
                        text-align: center;
                        line-height: 115px;
                      ">
                    {{ $t('common.noData') }}
                  </div> -->
                </div>
              </div>
            </div>
          </div>
          <div class="downBox">
            <div class="leftDown">
              <div class="upAll">
                <div class="title">
                  <span>{{ $t("HomPage.MasterKong.VehicleOperationDuration") }}</span>
                </div>
                <div style="width: 100%; padding: 8px 0 0">
                  <Table :height="height" :list="weekHourList" ref="weekHourTable" :options="option"
                    :columns="weekHourColumns">
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="12" class="homeCenter">
          <div id="allmap" ref="allmap" style="width: 100%; height: 100%"></div>
        </el-col>
        <el-col :span="6" class="homeRight">
          <div class="upBox">
            <div class="rightUp">
              <div class="upAll">
                <div class="title">
                  <i class="iconfont icon-paiming"></i><span>{{ $t('HomPage.MasterKong.DriverSituationAnalysis')
                  }}</span>
                </div>
                <el-row class="upFlex">
                  <el-col :span="12">
                    <div v-loading="DriverStatusLoading">
                      <linegraph :id="'DriverStatusBargraph'" :data="DriverStatusOption" style="height: 160px">
                      </linegraph>
                    </div>
                    <!-- <div v-else style="
                        color: #868686;
                        font-size: 16px;
                        text-align: center;
                        line-height: 115px;
                      ">
                      {{ $t('common.noData') }}
                    </div> -->
                  </el-col>
                  <el-col :span="10" class="flexLenged" style="margin-top: 40px;">
                    <div class="dotTitle"><span>上岗驾驶数(名)：</span><span style="color: #00FB82;">{{ driverWorkCount }}</span></div>
                    <div class="driverTitle"><span>未上岗驾驶数(名)：</span><span style="color: #0575FF;">{{ driverNoWorkCount }}</span></div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
          <div class="downBox">
            <div class="rightDown">
              <div class="upAll">
                <div class="title">
                  <span>{{ $t('HomPage.MasterKong.StatisticsDriversBranchOffices') }}</span>
                </div>
                <div>
                  <div v-loading="DriverStatisticsLoading">
                    <linegraph :id="'DriverStatisticsBargraph'" :data="DriverStatisticsOption" style="height: 230px">
                    </linegraph>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="downBox">
            <div class="rightDown">
              <div class="upAll">
                <div class="title">
                  <span>{{ $t('HomPage.MasterKong.DriverHourRank') }}</span>
                </div>
                <div style="width: 100%; padding: 8px 0 0">
                  <Table :height="height" :list="driveHourList" ref="driveHourTable" :options="option"
                    :columns="driveHourColumns">
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import HomeMasterKong from "./HomeMasterKong.js";
export default HomeMasterKong;
</script>

<style lang="less" scoped>
@import url("./HomeMasterKong.less");
</style>